import { Component, inject, signal } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FounderOffer } from '../../../models/subscription.model';

/**
 * Bandeau « Tarif fondateur » : le compteur affiché vient du serveur (abonnements réellement marqués
 * fondateur), jamais d'une valeur codée en dur. Masqué quand l'offre est terminée ou indisponible.
 */
@Component({
  selector: 'app-founder-banner',
  standalone: true,
  template: `
    @if (offer(); as o) {
      @if (o.enabled && o.remaining > 0) {
        <div
          class="inline-flex flex-col items-center gap-0.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-300 text-amber-900 dark:text-amber-200 rounded-xl px-5 py-3 text-sm"
          role="status"
        >
          <span class="font-bold"
            >🎖️ Tarif fondateur : -{{ o.percentOff }} % à vie</span
          >
          <span>
            Réservé aux {{ o.limit }} premiers abonnés :
            {{ o.remaining }} place{{ o.remaining > 1 ? 's' : '' }} restante{{
              o.remaining > 1 ? 's' : ''
            }}
            sur {{ o.limit }}
          </span>
        </div>
      }
    }
  `,
})
export class FounderBannerComponent {
  private api = inject(ApiService);
  readonly offer = signal<FounderOffer | null>(null);

  constructor() {
    this.api.getFounderOffer().subscribe({
      next: (o) => this.offer.set(o),
      error: () => this.offer.set(null),
    });
  }
}
